import * as React from 'react';

import { SUPPORT_ARTICLE_URL } from './merge_classes_prompt_modal';

import { requestDelete } from '../../../../modules/request/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';
import { ButtonSpinner } from '../../../Shared';
import DemoGuardedButton from '../shared/demoGuardedButton';

interface RestoreClassModalProps {
  classroomMerge: any;
  close: () => void;
  onSuccess: (snackbarCopy: string) => void;
  primaryClassroomName: string;
}

export const RestoreClassModal = ({ classroomMerge, close, onSuccess, primaryClassroomName, }: RestoreClassModalProps) => {
  const { modalRef } = useModalAccessibility(close)

  const [processingRequest, setProcessingRequest] = React.useState<boolean>(false)
  const [error, setError] = React.useState<string>(null)

  function handleRestoreClassButtonClick() {
    setProcessingRequest(true)
    setError(null)
    requestDelete(`/teachers/classroom_merges/${classroomMerge.id}`, null, () => {
      onSuccess('Class restored')
    }, (body) => {
      setProcessingRequest(false)
      setError(body?.error || 'Class could not be restored. Please try again.')
    })
  }

  return (
    <div className="modal-container restore-class-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="restoreClassModalTitle"
        aria-modal="true"
        className="restore-class-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="title-row">
          <h3 className="title" id="restoreClassModalTitle">Restore this class?</h3>
        </div>
        <div className="restore-class-modal-text">
          <p>If you restore <strong>{classroomMerge.secondary_classroom_name}</strong>, the students originally rostered in that class and their activity data will be removed from <strong>{primaryClassroomName}</strong>.</p>
          {error && <p className="error-message">{error}</p>}
        </div>
        <div className="form-buttons space-between">
          <a className="focus-on-light" href={SUPPORT_ARTICLE_URL} rel="noopener noreferrer" target="_blank">Learn more</a>
          <div className="right-side-buttons">
            <button className="quill-button outlined green medium focus-on-light" onClick={close} type="button">Cancel</button>
            <DemoGuardedButton className="quill-button contained green medium focus-on-light" disabled={processingRequest} onClick={handleRestoreClassButtonClick}>
              {processingRequest ? <ButtonSpinner variant="light" /> : 'Restore class'}
            </DemoGuardedButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RestoreClassModal
